/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationRoleModel } from '../../models/organization-role-model';

export interface OrganizationRoleIdGet$Params {
  id: string;
}

export function organizationRoleIdGet(http: HttpClient, rootUrl: string, params: OrganizationRoleIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationRoleModel>> {
  const rb = new RequestBuilder(rootUrl, organizationRoleIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<OrganizationRoleModel>;
    })
  );
}

organizationRoleIdGet.PATH = '/OrganizationRole/{id}';
